
{
  "fr": {
    "configurator": {
      "loading": "Chargement du configurateur en cours, merci de patienter…",
      "orientationLandscapeDisabled": "Pour une expérience optimale, merci d'utiliser votre appareil en mode portait",
      "homeBtn": {
        "title": "Retourner à l'accueil"
      }
    }
  }
}
